import { Text, Flex } from "@chakra-ui/react";
import { ContaRecorrenteItem } from "core/features/conta-recorrente/typings";
import { useMemo } from "react";
import { AiOutlineCalendar } from "react-icons/ai";
import colors from "core/resources/theme/colors";
import { getDateSubtitle } from "./../util/getDateSubtitle";
import TagGeracaoContaRecorrente from "./../components/TagGeracaoContaRecorrente";
import { formatMoney } from "infra/helpers/number";

function useContaRecorrenteColumns() {
  return useMemo(() => {
    return [
      {
        title: "Descrição",
        width: "25%",
        render: (original: ContaRecorrenteItem) => (
          <Flex flexDir="column">
            <Text lineHeight={"20px"} fontSize={14}>
              {original.descricao}
            </Text>
            <Flex gap="4px" alignItems="center">
              <AiOutlineCalendar />{" "}
              <Text color={colors.black} fontWeight="bold">
                {getDateSubtitle(original.dataInicio, original.dataFim)}
              </Text>
            </Flex>
          </Flex>
        ),
      },
      {
        title: "Pessoa",
        width: "25%",
        render: (original: ContaRecorrenteItem) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {original.pessoa.nome}
          </Text>
        ),
      },
      {
        title: "Valor",
        width: "10%",
        render: (original: ContaRecorrenteItem) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {formatMoney(original.valor ?? 0)}
          </Text>
        ),
      },
      {
        title: "Intervalo",
        width: "15%",
        render: (original: ContaRecorrenteItem) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {original.tipoIntervaloRepeticao.nome}
          </Text>
        ),
      },
      {
        title: "Dia",
        width: "10%",
        render: (original: ContaRecorrenteItem) => (
          <Text lineHeight={"20px"} fontSize={14}>
            {original.diaVencimento ?? ""}
          </Text>
        ),
      },
      {
        title: "",
        width: "15%",
        render: (original: ContaRecorrenteItem) => (
          <TagGeracaoContaRecorrente gerada={original.gerada} />
        ),
      },
    ];
  }, []);
}

export default useContaRecorrenteColumns;
